define('editor/edit/layers/add/geojson/index',['durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'jquery'], function (app, http, ko, komapping, $) {
    var viewmodel = function() {
        var self = this;

        self.rawGeoJson = ko.observable();
        self.dragHelp = ko.observable('drop a .json file here (Max 500KB)');

        self.activate = function(mapId, cancelFunc) {
            self.mapId = mapId;
            self.exit = cancelFunc;
        };

        self.compositionComplete = function () {
            self.filedrag = $("#file-drop").get(0);
            
            self.filedrag.addEventListener("dragover", self.fileDragHover, false);
            self.filedrag.addEventListener("dragleave", self.fileDragHover, false);
            self.filedrag.addEventListener("drop", self.fileSelectHandler, false);
        };
        
        // file drag hover
        self.fileDragHover = function(e) {
            e.stopPropagation();
            e.preventDefault();
        };
        
        self.fileSelectHandler = function (e) {
            e.stopPropagation();
            e.preventDefault();
            
            // fetch FileList object
            var files = e.dataTransfer.files;

            // process all File objects
            for (var i = 0; i < files.length; i++) {
                var f = files[i];

                if (f.size > 500000) {
                    return app.showMessage("The file is too large (500 KB max)");
                }
                
                self.parseFile(f);
            }
        };

        self.parseFile = function (file) {
            var reader = new FileReader();
            
            reader.onload = function (e) {
                self.dragHelp(file.name);
                self.rawGeoJson(e.target.result);
            };

            reader.readAsText(file);
        };

        self.save = function() {
            var json = $.parseJSON(self.rawGeoJson());
            var isCollection = json.type ? json.type.toLowerCase().indexOf("collection") >= 0 : false;
            var isGeometryCollection = json.type ? json.type.toLowerCase() === "geometrycollection" : false;

            if (isGeometryCollection) {
                json = self.convertGeometryCollectionToFeatureCollection(json);
            }

            if (isCollection) {
                self.saveFeatureCollection(json);
            } else {
                self.saveSingleFeature(json);
            }
        };

        self.convertGeometryCollectionToFeatureCollection = function (json) {
            return {
                type: "FeatureCollection",
                features: $.map(json.geometries, self.featureFromGeometry)
            };
        };

        self.featureFromGeometry = function (geom) {
            return {
                type: "Feature",
                properties: geom.properties || {},
                geometry: {
                    type: geom.type,
                    coordinates: geom.coordinates
                }
            };
        };

        self.saveFeatureCollection = function (featureCollection) {
            var data = self.buildFeatureCollectionPostBody(featureCollection);

            self.saveGroupedLayers(data)
                .then(function () {
                    app.trigger('layers:available');
                    self.exit();
                })
                .fail(app.showError);
        };

        self.buildFeatureCollectionPostBody = function (featureCollection) {
            var collectionLen = featureCollection.features.length,
                feature,
                dto = {
                    editorMapId: self.mapId,
                    layers: []
                };

            for (var i = 0; i < collectionLen; i++) {
                feature = featureCollection.features[i];
                
                self.addFeatureStyleProperties(feature);
                
                dto.layers.push({
                    name: feature.properties.name || '',
                    type: 'GeoJSON',
                    state: feature
                });
            }

            return dto;
        };

        self.saveSingleFeature = function (feature) {
            self.addFeatureStyleProperties(feature);

            self.saveSingleLayer(feature)
                    .then(self.exit)
                    .fail(app.showError);
        };

        self.addFeatureStyleProperties = function (feature) {
            var shapeOptions = { // from L.Draw.Polygon.options.shapeOptions
                stroke: true,
                color: '#ff0000',
                weight: 2,
                opacity: 0.5,
                fill: true,
                fillColor: null, //same as color by default
                fillOpacity: 0.2,
                clickable: true
            };

            feature.properties = feature.properties || {};
            
            $.extend(feature.properties, shapeOptions);
        };
        
        self.saveSingleLayer = function (json) {
            var url = "/api/editor/layers/add",
                data = {
                    editorMapId: self.mapId,
                    type: 'GeoJSON',
                    state: json
                };

            return http.post(url, data)
                .then(function(response) {
                    if (response.success) {
                        var layerData = response.data["createdLayer"],
                            layerState = komapping.fromJS(layerData.state),
                            layer = {
                                id: ko.observable(layerData.id),
                                name: ko.observable(layerData.name),
                                groupId: ko.observable(data.groupId),
                                groupName: ko.observable(data.groupName),
                                groupColour: ko.observable(data.groupColour),
                                visible: ko.observable(layerData.visible),
                                type: ko.observable(layerData.type),
                                order: ko.observable(layerData.order),
                                state: ko.observable(layerState)
                            };

                        delete layerState['__ko_mapping__'];

                        app.trigger("layer:new", layer);
                    } else {
                        app.showMessage("Failed to add layer", "Add Layer");
                    }
                });
        };

        self.saveGroupedLayers = function (data) {
            var url = "/api/editor/layers/addmulti";

            return http.post(url, data);
        };
    };

    return viewmodel;
});

